(function () {
  var SLIDE_MS = 9000; // maximale tijd per video voordat de carrousel doorschuift

  function init(root) {
    // Het script staat in de sectie; bij twee reels-secties op één pagina niet dubbel initialiseren.
    if (root.getAttribute('data-reels-ready')) return;
    root.setAttribute('data-reels-ready', '1');

    var track = root.querySelector('[data-reels-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-reel]'));
    if (!track || slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-reels-dot]'));
    var toggle = root.querySelector('[data-reels-toggle]');
    var toggleLabel = root.querySelector('[data-reels-toggle-label]');
    var sound = root.querySelector('[data-reels-sound]');
    var soundLabel = root.querySelector('[data-reels-sound-label]');
    var prev = root.querySelector('[data-reels-prev]');
    var next = root.querySelector('[data-reels-next]');

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var wanted = !reduceMotion; // wil de bezoeker afspelen?
    var inView = false;

    function videoAt(i) { return slides[i] ? slides[i].querySelector('video') : null; }

    // Posters pas ophalen als het blok in beeld komt — anders vechten vier
    // stilstaande beelden bij het laden om bandbreedte met de hero-afbeelding.
    function showPosters() {
      slides.forEach(function (slide) {
        var v = slide.querySelector('video');
        if (!v) return;
        var p = v.getAttribute('data-poster');
        if (p && !v.getAttribute('poster')) v.setAttribute('poster', p);
      });
    }

    function stopTimer() {
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function startTimer() {
      stopTimer();
      if (slides.length < 2) return;
      var v = videoAt(index);
      var ms = SLIDE_MS;
      // Korte video's krijgen hun eigen lengte, lange worden afgekapt op SLIDE_MS.
      if (v && isFinite(v.duration) && v.duration > 0) {
        ms = Math.min(SLIDE_MS, Math.ceil(v.duration * 1000));
      }
      timer = setTimeout(function () { go(index + 1); }, ms);
    }

    function playing() { return wanted && inView; }

    function sync() {
      slides.forEach(function (slide, i) {
        var active = i === index;
        // aria-hidden moet letterlijk "true" zijn; een leeg attribuut leest als zichtbaar.
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
        var v = slide.querySelector('video');
        if (!v) return;
        if (active) {
          // Pas metadata ophalen als het blok in beeld is. Anders begint de browser
          // al bij het laden van de pagina te downloaden, terwijl dit blok onderaan
          // staat — dat kostte honderden kilobytes die de hero-afbeelding vertraagden.
          if (inView) v.preload = 'metadata';
          if (playing()) {
            var p = v.play();
            if (p && p.catch) p.catch(function () { /* autoplay geweigerd: poster blijft staan */ });
          } else {
            v.pause();
          }
        } else {
          v.pause();
          if (v.currentTime) { try { v.currentTime = 0; } catch (e) { /* niet-seekbaar */ } }
        }
      });
      // De eerstvolgende video vast laten inladen zodat de overgang vloeit — ook dit
      // pas wanneer het blok in beeld is.
      if (inView) {
        var upcoming = videoAt((index + 1) % slides.length);
        if (upcoming && upcoming.preload === 'none') upcoming.preload = 'metadata';
      }

      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      track.style.transform = 'translateX(' + (index * -100) + '%)';
      root.toggleAttribute('data-paused', !wanted);
      if (toggleLabel) toggleLabel.textContent = wanted ? 'Pauzeer' : 'Afspelen';
      if (toggle) toggle.setAttribute('aria-label', wanted ? "Pauzeer de video's" : "Speel de video's af");
    }

    function go(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      sync();
      if (playing()) startTimer(); else stopTimer();
    }

    // Als een video eerder klaar is dan de timer, meteen door.
    slides.forEach(function (slide, i) {
      var v = slide.querySelector('video');
      if (!v) return;
      v.addEventListener('ended', function () {
        if (i === index && playing()) go(index + 1);
      });
      // Zodra de echte duur bekend is, de timer daarop bijstellen.
      v.addEventListener('loadedmetadata', function () {
        if (i === index && playing()) startTimer();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        wanted = !wanted;
        sync();
        if (playing()) startTimer(); else stopTimer();
      });
    }

    if (sound) {
      sound.addEventListener('click', function () {
        var on = !root.hasAttribute('data-sound');
        root.toggleAttribute('data-sound', on);
        sound.setAttribute('aria-pressed', on ? 'true' : 'false');
        sound.setAttribute('aria-label', on ? 'Zet het geluid uit' : 'Zet het geluid aan');
        if (soundLabel) soundLabel.textContent = on ? 'Geluid uit' : 'Geluid aan';
        slides.forEach(function (slide) {
          var v = slide.querySelector('video');
          if (v) v.muted = !on;
        });
      });
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(index - 1); }
      else if (e.key === 'ArrowRight') { go(index + 1); }
    });

    // Alleen spelen wanneer het blok echt in beeld staat — scheelt data en batterij.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (inView) showPosters();
          sync();
          if (playing()) startTimer(); else stopTimer();
        });
      }, { threshold: 0.4 }).observe(root);
    } else {
      inView = true;
      showPosters();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stopTimer(); slides.forEach(function (s) { var v = s.querySelector('video'); if (v) v.pause(); }); }
      else { sync(); if (playing()) startTimer(); }
    });

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-reels]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // De theme editor hangt secties opnieuw in de DOM.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-reels]');
    if (root) init(root);
  });
})();
